import React, { Fragment, useEffect } from "react";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";
import { fetchDeleteGallery, fetchGalleryList } from "../actions/gallery";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { statusRender } from "../utils/cellRenderTable";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const GalleryList = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "gallery";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { galleryList } = useSelector((state) => state.galleryReducer);

  useEffect(() => {
    dispatch(fetchGalleryList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    return (
      <ButtonColumn
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const imageRenderer = (params) => {
    if (!params.data || !params.data.image || !params.data.name) return null;
    return (
      <img
        src={params.data.image}
        alt={params.data.name}
        className="image-aggrid-cell"
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(fetchDeleteGallery(pageId));
  };

  //settings za tabelu
  const columnDefs = [
    {
      headerName: t("galleryList.name"),
      field: "name",
      filter: "agTextColumnFilter",
      width: 180,
    },
    {
      headerName: t("galleryList.image"),
      field: "image",
      width: 180,
      cellRenderer: imageRenderer,
    },
    {
      headerName: t("galleryList.imagePath"),
      field: "image",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
    },
    {
      headerName: t("galleryList.createdAt"),
      field: "createdAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: t("galleryList.updatedAt"),
      field: "updatedAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 80,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={galleryList}
        columnDefs={columnDefs}
        buttonLink={`/gallery-add`}
        buttonText={t("breadcrumb.galleryAdd")}
        gridStateKey={"gallery-list"}
      />
    </Fragment>
  );
};

export default GalleryList;
